export enum LoginModes {
  Auth0 = 'Auth0',
  Sorenson = 'Sorenson',
}
